import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getPhysicianPaymentData = createAsyncThunk(
  "physicianPayment/getPhysicianDataById",
  async (physicianData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physicianPayment/getPhysicianDataById",
        physicianData,
        {
          headers: {
            "Content-Type": "application/json",
            token: physicianData.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const doPhyisicianPayment = createAsyncThunk(
  "physicianPayment/doPhysicianPayments",
  async (physicianData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/physicianPayment/doPhysicianPayments",
        physicianData,
        {
          headers: {
            "Content-Type": "application/json",
            token: physicianData.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const PhysicianDetails = createSlice({
  name: "physicianData",
  initialState: {
    loading: false,
    successMessage: null,
    errorMessage: null,
    physicianPaymentData: [],
  },
  reducers: {
    resetMessage: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPhysicianPaymentData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPhysicianPaymentData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
          state.physicianPaymentData = [];
        } else {
          state.physicianPaymentData = action.payload.result.list;
          state.searchMessage = null;
        }
      })
      .addCase(getPhysicianPaymentData.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(doPhyisicianPayment.pending, (state) => {
        state.loading = true;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(doPhyisicianPayment.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === true) {
          state.successMessage = action.payload.result.message;
        } else {
          state.errorMessage = action.payload.result.message;
        }
      })
      .addCase(doPhyisicianPayment.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      });
  },
});
export const { resetMessage } = PhysicianDetails.actions;
export default PhysicianDetails.reducer;
